import { DOCUMENT } from "@angular/common";
import { Directive, ElementRef, HostListener, Inject } from "@angular/core";

@Directive({
    selector: "[doNotPropagateClick]"
})
export class DoNotPropagateClickDirective {
    private htmlEl: { click: (ev: PointerEvent) => void };

    constructor(el: ElementRef<Element>, @Inject(DOCUMENT) document: Document) {
        this.htmlEl = <HTMLElement>(el.nativeElement.ownerDocument?.children[0] ?? document?.children[0]);
    }

    @HostListener("click", ["$event"]) stopPropagation(e: PointerEvent) {
        e.stopPropagation();

        if (typeof this.htmlEl.click === "function") {
            this.htmlEl.click(e);
        }

        return false;
    }
}

@Directive({
    selector: "[doNotPropagateClick]",
    standalone: true
})
export class DoNotPropagateClickStandaloneDirective extends DoNotPropagateClickDirective {
    constructor(el: ElementRef<Element>, @Inject(DOCUMENT) document: Document) {
        super(el, document);
    }
}
